export const ForValidationOtherCountryPhone = [
  {
    value_abbr: 'UA',
    length: 13,
    dial_code: '+38 0',
    mask: '## ### ## ##'
  }
]

export const phoneNumbers = [
  { '0800304114': '0 800 30 41 14' },
  { '+380687074114': '068' },
  { '+380737074114': '073' },
  { '+380507074114': '050' },
  { '+380617074114': '061' }
]

export const socialLinks = [
  {
    img: 'icon-instagram.svg',
    link: 'https://www.instagram.com/dianet.official/',
    alt: 'altInstagram'
  },
  {
    img: 'icon-facebook.svg',
    link: 'https://www.facebook.com/dianet.official',
    alt: 'altFacebook'
  },
  {
    img: 'icon-viber.svg',
    link: 'viber://pa?chatURI=dianet',
    alt: 'altViber'
  },
  {
    img: 'icon-telegram.svg',
    link: 'https://t.me/DiaNet_bot',
    alt: 'altTelegram'
  }
]

export const emails = {
  support: 'support@dianet.online'
}

// export const paySystems =
// ['ApplePay', 'Privat24', 'EasyPay', 'Liqpay', 'Google Pay']

export const paySystems = ['Privat24', 'EasyPay', 'Liqpay', 'MonoPay'] //'Запорожсвязьсервис'

export const payPrice = [100, 200, 500]

export const mapLink = 'https://map.dianet.online/'

export const officeCoordinates = {
  left: {
    lat: '47.781142',
    lan: '35.20635499999999'
  },
  right: {
    lat: '47.87595',
    lan: '35.062208'
  }
}

export const whiteIps = [
  'Fiz Real IP',
  'Free Real IP',
  'RealIP за гривну/день',
  'Real_ip_50_per_month',
  'UR Real IP',
  'Real IP'
]

export const tvProviders = {
  sweetTv: 'Trinity',
  megogo: 'Megogo'
}

export const tvServiceToStatusKey = {
  sweetTv: 'trinity',
  megogo: 'megogo'
}

export const tvStatuses = {
  ACTIVE: 0,
  ADMIN_BLOCKED: 1,
  NOT_ACTIVATED: 2,
  FROZEN: 3,
  LOW_BALANCE: 5,
  DEACTIVATED: 9,
  PAUSED: 14
}

export const BLOCKING_TV_STATUSES = [tvStatuses.ADMIN_BLOCKED, tvStatuses.FROZEN, tvStatuses.LOW_BALANCE]

export const tvIconByTpId = {
  default: 'promo.webp',
  92: 'promo.webp',
  15: 'promo.webp',
  20: 'minimal.webp',
  23: 'middle.webp',
  24: 'max.webp',
  30: 'megogo.webp',
  42: 'megogo.webp',
  36: 'megogo.webp',
  37: 'megogo.webp',
  38: 'megogo.webp'
}

export const internetIconByTpId = {
  default: 'car-wheel.webp',
  4: 'car-wheel.webp',
  9: 'flaming-wheel.webp',
  41: 'car-wheel.webp',
  42: 'speedometer.webp',
  63: 'flaming-wheel.webp',
  64: 'ice-wheel.webp',
  200: 'ice-wheel.webp',
  222: 'stopwatch.webp',
  223: 'game-console.webp',
  224: 'pc-tower.webp',
  225: 'vr-headset.webp',
  226: 'stopwatch.webp',
  227: 'game-console.webp',
  228: 'pc-tower.webp',
  229: 'vr-headset.webp'
}

export const absentTariff = {
  id: null,
  tariff_id: null,
  name_uk: 'Не обрано',
  name_ru: 'Не выбрано',
  count_channels: 0,
  month_fee: 0
}

export const SUCCESS_CODES = [200, 201, 204]

export const WHITE_IP_DAILY_PRICE = 2.5

export const FREEZE_DAILY_PRICE = 1

export const FREEZE_MIN_PERIOD_DAYS = 3

export const CREDIT_PERIOD_DAYS = 3

export const GOOGLE_REMINDER_KEY = 'remind_google_auth_later_until'

export const SERVICE_TYPE = Object.freeze({
  FREEZE: 1,
  PAUSE: 2
})

export const CLIENT_TYPE = Object.freeze({
  LEGAL: 11
})

export const ACCOUNT_STATE = Object.freeze({
  ACTIVE: 0,
  FREEZE: 3,
  SMALL_DEPOSIT: 5,
  BLOCKED: 14
})
